import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
import { useFieldControl } from "./Field.js";
const Select = React.forwardRef(function Select2(props, ref) {
  const { className, ...rest } = useFieldControl(props);
  return /* @__PURE__ */ jsx("select", { ref, className: cx("ev-select", className), ...rest });
});
Select.displayName = "Select";
export {
  Select
};
//# sourceMappingURL=Select.js.map
